export type PaymentTermsMethod = "cash" | "credit" | null;

const ARABIC_DIACRITICS = /[\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06ed]/g;

/**
 * Normalizes Arabic spelling differences that do not change the meaning of
 * payment terms. This intentionally does not translate arbitrary free text.
 */
function normalizeArabicPaymentTerms(paymentTerms: string): string {
  return paymentTerms
    .normalize("NFKC")
    .replace(ARABIC_DIACRITICS, "")
    .replace(/\u0640/g, "")
    .replace(/[أإآٱ]/g, "ا")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Classifies the supported payment-term values used by receipt validation.
 * Cash remains restricted to its canonical value; Arabic credit labels are
 * deliberately allow-listed after normalizing hamza and diacritics.
 */
export function classifyPaymentTerms(paymentTerms: string): PaymentTermsMethod {
  const terms = paymentTerms.trim();
  if (terms === "cash_on_delivery") return "cash";
  if (terms === "end_of_month" || /^net_\d+$/i.test(terms)) return "credit";

  const arabicTerms = normalizeArabicPaymentTerms(terms);
  if (["اجل", "بالاجل", "دفع اجل", "على الاجل"].includes(arabicTerms)) return "credit";

  return null;
}